import * as mobx from 'mobx';
import { ConnectionType, IConnectionDetailsDTO, IPanelistLinkConnectionInfo } from '../../../../../../api/connections.dao';
import { IAttendeeOrganizationDTO } from '../../../../../../api/attendees.dao';
import { ConnectionVersion } from '../../../../../../constants/common.constants';
import { SPACE_IN_BEGIN_REG_EXP } from '../../../../../../constants/regex.constants';

class CreatePanelistLinkFormDataVM {
    @mobx.observable
    private webinarID: string;
    @mobx.observable
    private attendeeID: number;
    @mobx.observable
    private attendeeName: string;
    @mobx.observable
    private attendeeEmail: string;
    @mobx.observable
    private meetingConnectionId: number;
    @mobx.observable
    private parentJoinMethodId: number;

    constructor(
        private readonly webinarDetails: IConnectionDetailsDTO[],
        private readonly presentersList: IAttendeeOrganizationDTO[],
        private readonly hostsList: IAttendeeOrganizationDTO[],
        private readonly supportsList: IAttendeeOrganizationDTO[],
        private readonly connectionVersion?: ConnectionVersion,
    ) {
        this.cleanup();
    }

    public getWebinarID = (): string => {
        return this.webinarID;
    };

    public getAttendeeID = (): number => {
        return this.attendeeID;
    };

    public getAttendeeName = (): string => {
        return this.attendeeName;
    };

    public getAttendeeEmail = (): string => {
        return this.attendeeEmail;
    };

    public getWebinarDetails = (): IConnectionDetailsDTO[] => {
        return this.webinarDetails;
    };

    public getPresenters = (): IAttendeeOrganizationDTO[] => {
        return this.presentersList;
    };

    public getHosts = (): IAttendeeOrganizationDTO[] => {
        return this.hostsList;
    };

    public getSupport = (): IAttendeeOrganizationDTO[] => {
        return this.supportsList;
    };

    public getConnectionVersion = (): ConnectionVersion => {
        return this.connectionVersion;
    };

    public getParentMeetingConnectionID = (): number => {
        return this.meetingConnectionId;
    };

    public getParentJoinMethodID = (): number => {
        return this.parentJoinMethodId;
    };

    public handleWebinarChange = (connectionId: string): void => {
        const selectedWebinar = this.webinarDetails.find(webinar => webinar.connectionId === connectionId);
        if (selectedWebinar) {
            this.setWebinarID(selectedWebinar.connectionId.replace(SPACE_IN_BEGIN_REG_EXP,''));
            this.setParentMeetingConnectionID(selectedWebinar.meetingConnectionId);
            this.setParentJoinMethodID(selectedWebinar.joinMethodId);
        }
    };

    @mobx.action
    public setWebinarID = (webinarId: string): void => {
        this.webinarID = webinarId;
    };

    @mobx.action
    public setAttendeeID = (attendeeId: number): void => {
        this.attendeeID = attendeeId;
    };

    @mobx.action
    public setAttendeeName = (attendeeName: string): void => {
        this.attendeeName = attendeeName;
    };

    @mobx.action
    public setAttendeeEmail = (attendeeEmail: string): void => {
        this.attendeeEmail = attendeeEmail;
    };

    @mobx.action
    public setParentMeetingConnectionID = (meetingConnectionId: number): void => {
        this.meetingConnectionId = meetingConnectionId;
    };

    @mobx.action
    public setParentJoinMethodID = (joinMethodId: number): void => {
        this.parentJoinMethodId = joinMethodId;
    };

    public getAPIDTO = (): IPanelistLinkConnectionInfo => {

        const dataToDTO = {
            type: ConnectionType.PanelistLink,
            webinarID: this.webinarID,
            attendeeID: this.attendeeID,
            attendeeName: this.attendeeName,
            email: this.attendeeEmail,
            parentJoinMethodId: this.parentJoinMethodId,
            parentMeetingConnectionId: this.meetingConnectionId,
        };
        return dataToDTO;
    };

    @mobx.action
    public cleanup = (): void => {
        this.webinarID = this.webinarDetails[0]?.connectionId;
        this.attendeeID = null;
        this.attendeeName = '';
        this.meetingConnectionId = this.webinarDetails[0]?.meetingConnectionId;
        this.parentJoinMethodId = this.webinarDetails[0]?.joinMethodId;
    };

}

export { CreatePanelistLinkFormDataVM };